import { useCallback, useState } from 'react';
import { acceptPrivacy } from '../api';

// Этап 30: «турникет» повторного ознакомления с Политикой обработки ПДн.
// Показывается существующему пользователю, когда его сохранённая версия согласия
// не совпадает с актуальной (Оператор обновил Политику). Блокирует доступ к
// каталогу/кабинету до подтверждения. «Свежие» пользователи сюда не попадают —
// они дают согласие в форме регистрации.
export default function PrivacyGatePage({ onAccepted }: { onAccepted: () => void }) {
  const [accepted, setAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = useCallback(async () => {
    if (!accepted || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await acceptPrivacy();
      onAccepted();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  }, [accepted, submitting, onAccepted]);

  const canConfirm = accepted && !submitting;

  return (
    <div className="container" style={{ padding: '28px 16px 40px', maxWidth: 560, margin: '0 auto' }}>
      <h2 style={{ margin: '0 0 8px', fontSize: 20, color: 'var(--tg-text)' }}>
        Политика обработки персональных данных обновлена
      </h2>
      <p style={{ margin: '0 0 20px', fontSize: 14, lineHeight: 1.5, color: 'var(--tg-hint)' }}>
        Мы обновили Политику обработки персональных данных. Чтобы продолжить
        пользоваться сервисом, пожалуйста, ознакомьтесь с актуальной редакцией и
        подтвердите согласие.
      </p>

      <label
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 10,
          cursor: 'pointer',
          fontSize: 13,
          lineHeight: 1.45,
          color: 'var(--tg-text)',
          marginBottom: 16,
        }}
      >
        <input
          type="checkbox"
          checked={accepted}
          onChange={e => setAccepted(e.target.checked)}
          style={{ width: 20, height: 20, flexShrink: 0, marginTop: 1, accentColor: 'var(--tg-button)' }}
        />
        <span>
          Я ознакомлен(а) с{' '}
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--tg-link, #2481cc)', textDecoration: 'underline' }}
          >
            Политикой обработки персональных данных
          </a>{' '}
          и даю согласие на обработку моих персональных данных.
        </span>
      </label>

      <button
        onClick={handleConfirm}
        disabled={!canConfirm}
        style={{
          width: '100%',
          padding: '14px 0',
          border: 'none',
          borderRadius: 12,
          background: canConfirm ? 'var(--tg-button)' : 'var(--tg-secondary-bg)',
          color: canConfirm ? 'var(--tg-button-text)' : 'var(--tg-hint)',
          fontSize: 15,
          fontWeight: 600,
          fontFamily: 'inherit',
          cursor: canConfirm ? 'pointer' : 'not-allowed',
          transition: 'background 0.15s',
        }}
      >
        {submitting ? 'Сохранение…' : (accepted ? 'Подтвердить' : 'Отметьте согласие выше')}
      </button>

      {error && (
        <p style={{ marginTop: 12, fontSize: 13, color: 'var(--tg-destructive-text, #e53935)', textAlign: 'center' }}>
          Не удалось сохранить согласие: {error}
        </p>
      )}
    </div>
  );
}
